import React from 'react';
import { Glyphicon } from 'react-bootstrap'
import CreatableAsync from 'react-select/lib/AsyncCreatable'
import Highlighter from 'react-highlight-words';
import API from 'fw/system/API'

class SearchBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			className: this._className(),
			value: props.value,
			text: props.text
		};
	}

	// Public API
	setValue = (value) => {
		//this._update(value, this._parse(value), this._format(value));
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		// this._select.focus();
	}

	select = () => {
		this._select.select();
	}

	flag = (status) => {
		if (!status)
			this.setState((prevState) => {
				return { className: prevState.className + " invalid-field" }
			});
		else
			this.setState((prevState) => {
				return { className: prevState.className.replace("invalid-field", "") }
			});
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		if (this.state.value !== null && this.state.value !== "")
			this.props.onSubmit(new Event("submit"));

		this._select.blur();
	}

	// Private
	_handleChange = (item) => {
		const me = this;
		let value = null;

		if (item !== null) {
			value = item.value;
		}

		this.setState({
			value: value,
			text: value
		}, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);

			const status = requiredPassed && validationPassed;

			this.flag(status);
			this.onDirt();

			// Update value field in form
			if (me.props.managed) {
				this.props.onFieldChange(value, this.props.name, function () { me.onChange(item); });
			}
			else {
				this.onChange(item);
			}
		});
	}

	_loader = (query, callback) => {
		if (query.length < this.props.minlength)
			return callback(null, { options: [] });

		const rq = {
			query: query
		};

		// Get loader options from caller
		const loaderOpts = this.props.loader();

		// Prepare request with query + params
		Object.assign(rq, loaderOpts.params);

		new API().get(loaderOpts.url, rq,
			{
				success: function (response) {
					// Transform C# dictionary into value/label array needed
					var keys = Object.getOwnPropertyNames(response.data.items);
					var values = Object.values(response.data.items);

					var options = keys.map((key, index) => {
						return {
							value: key,
							label: values[index]
						}
					});

					// Return objects
					callback(options);
				}
			},
			{
				block: false
			});
	}

	_handleBlur = (e) => {
		if (!this.props.searchOnBlur)
			return;
		
		if (e.target.value !== "")
			this._handleChange({ value: e.target.value });
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextState.value !== this.state.value
			|| nextState.className !== this.state.className);
	}

	componentWillReceiveProps(nextProps, nextState) {
		this.setState({
			value: nextProps.value,
			text: nextProps.text
		});
	}

	render() {
		let value = {
			value: this.state.value,
			label: this.state.value
		};

		// So the place holder appears
		if (!this.state.value || this.state.value === "")
			value = null;

		let opts = {
			name: this.props.name,
			value: value,
			placeholder: this.props.placeholder,
			SearchBoxload: this.props.SearchBoxload,
			className: this.state.className,
			onChange: this._handleChange,
			onBlur: this._handleBlur,
			loadOptions: this._loader,
			isDisabled: this.props.disabled,
			isClearable: true,
			allowCreateWhileLoading: true,
			createOptionPosition: "first",
			onFocus: () => {
                if (!!this.state.value)
                    this._select.select.state.inputValue = this.state.value;
			},
			onCreateOption: () => {
				this._select.blur();
			},
			noOptionsMessage: function () {
				return "Type to search...";
			},
			formatCreateLabel: function (v) {
				return "Search for '" + v + "'...";
			},
			formatOptionLabel: function (option, context) {
				return (<Highlighter
                    autoEscape
					highlightClassName="search-box-highlight"
					searchWords={[context.inputValue]}
					textToHighlight={option.label} />);
			}

		};

		const customStyles = {
			container: (base, state) => {
				if (!state.isDisabled)
					return {
						...base,
						backgroundColor: "transparent"
					}
				else
					return {
						...base,
						backgroundColor: "#eee"
			}},
			singleValue: (provided, state) => ({
				...provided,
				top: "10px",
				color: "#555"
			}),
			placeholder: (provided, state) => ({
				...provided,
				top: "10px",
                color: "#999",
                whiteSpace: "nowrap"
			}),
			input: (provided, state) => ({
				...provided,
				marginTop: -2,
				margin: 0,
				paddingBottom: 0,
				paddingTop: 0
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				width: 0
			}),
			indicatorsContainer: (provided, state) => ({
				...provided,
				cursor: 'pointer'
			}),
			control: (provided, state) => ({
				...provided,
				height: 34,
				minHeight: 34,
				boxShadow: 0,
				borderRadius: 0
			}),
			menu: (provided, state) => ({
				...provided,
				marginTop: 0
			}),
			noOptionsMessage: (provided, state) => ({
				...provided,
				marginLeft: 0,
				height: 20,
				padding: 0,
				marging: 0
			}),
			dropdownIndicator: (base, state) => ({
				...base,
				display: 'none'
			}),
			clearIndicator: (base, state) => ({
				...base,
				width: '30px',
				marginRight: '25px'
			}),
			loadingIndicator: (base, state) => ({
				...base,
				marginRight: '0px'
			}),
			menuContainerStyle: () => ({
				zIndex: "999 !important"
			})
		}

		return (
			<div>
				<CreatableAsync {...opts}
					styles={customStyles}
					ref={(select) => { this._select = select; }} />
				<Glyphicon className="pull-right" glyph="search" style={{ color: "#bbb", marginTop: "-27px", marginRight: "10px" }} />
			</div>);
	}
}

SearchBox.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false,
	SearchBoxload: true,
	minlength: 2,
	searchOnBlur: true
};

export default SearchBox;


// WEBPACK FOOTER //
// ./src/fw/forms/controls/searchBox/SearchBox.js